import Vue from 'vue'
import Vuex from 'vuex'
import router from '@/router/router.js';
import '@/plugins/vuetify'
import '@/plugins/wew'
import firebase from 'firebase/app'
import 'firebase/firestore'

import App from './App.vue'

Vue.config.productionTip = false
Vue.use(Vuex)

import { firestorePlugin } from 'vuefire'
Vue.use(firestorePlugin)

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')


firebase.initializeApp({
  projectId: 'rescms-ff2d2',
  databaseURL: 'https://rescms-ff2d2.firebaseio.com'
})

export const db = firebase.firestore()